"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderConverter = void 0;
const LinkEntity_1 = require("../../../common/model/LinkEntity");
class ProviderConverter {
    static convert(entity) {
        return {
            id: entity.id,
            name: entity.name,
            types: entity.types,
            description: entity.description,
            logoUrl: entity.logoUrl,
            defaultThemeLogoUrl: entity.defaultThemeLogoUrl,
            navigationPath: entity.navigationPath,
            hidden: entity.hidden,
            links: {
                updateProvider: entity._links?.updateProvider
                    ? new LinkEntity_1.Link(entity._links.updateProvider)
                    : undefined,
                renameProviderType: entity._links?.renameProviderType
                    ? new LinkEntity_1.Link(entity._links.renameProviderType)
                    : undefined,
            },
        };
    }
}
exports.ProviderConverter = ProviderConverter;
//# sourceMappingURL=ProviderConverter.js.map